module.exports = __webpack_public_path__ + "static/img/profile.289f5d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/profile.png
// module id = SONO
// module chunks = 1